var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.6 26.399a2.4 2.4 0 002.4 2.4l16 .001a2.4 2.4 0 002.4-2.4l-20.8-.001zM17.2 6.8c0 .66-.54 1.2-1.2 1.2-.66 0-1.2-.54-1.2-1.2V4.4c0-.66.54-1.2 1.2-1.2.66 0 1.2.54 1.2 1.2v2.4zM24.4 6.8c0 .66-.54 1.2-1.2 1.2-.66 0-1.2-.54-1.2-1.2V4.4c0-.66.54-1.2 1.2-1.2.66 0 1.2.54 1.2 1.2v2.4zM10 6.8C10 7.46 9.46 8 8.8 8c-.66 0-1.2-.54-1.2-1.2V4.4c0-.66.54-1.2 1.2-1.2.66 0 1.2.54 1.2 1.2v2.4zM25.6 15.6l-4.801-4.8 4.8 4.8zM25.6 10.8l-4.8 4.8 4.8-4.8zM11.2 10.8H6.4v4.8h4.8v-4.8zM18.4 10.8h-4.8v4.8h4.8v-4.8zM11.2 18H6.4v4.8h4.8V18zM18.4 18h-4.8v4.8h4.8V18zM25.6 18h-4.8v4.8h4.8V18z",
    stroke: "#836F50",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4 5.6h-2v1.2c0 .66-.54 1.2-1.2 1.2-.66 0-1.2-.54-1.2-1.2V5.6h-4.8v1.2c0 .66-.54 1.2-1.2 1.2-.66 0-1.2-.54-1.2-1.2V5.6H10v1.2C10 7.46 9.46 8 8.8 8c-.66 0-1.2-.54-1.2-1.2V5.6h-2A2.4 2.4 0 003.2 8v16a2.4 2.4 0 002.4 2.4h20.8a2.4 2.4 0 002.4-2.4V8a2.4 2.4 0 00-2.4-2.4z",
    stroke: "#836F50",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.e721d205bfc14c9aee0c893df2992380.svg";
export { ForwardRef as ReactComponent };